export class Counter {
  constructor(private value: number = 0) {}

  get(): number {
    return this.value
  }

  increment(): number {
    this.value += 1
    return this.value
  }
}
